export const JAB_CHAT_ORG = "332a9d47-6e36-11e8-a392-061714f61e3e";

// Applies to the shared current web client, including direct workflow sends and
// 403/404 hydration. Existing/native clients still need a separately approved
// Stream permission policy; this transport guard is not provider authorization.
export function installJobChatGuard(client, getOrgId, access) {
  for (const method of ["post", "patch"]) {
    if (typeof client[method] !== "function") continue;
    const original = client[method];
    client[method] = async function(url, body, ...rest) {
      const path = String(url).split("?")[0];
      const orgId = getOrgId();
      if (orgId === JAB_CHAT_ORG && method === "post" && /\/channels$/.test(path)) {
        body = { ...body, filter_conditions: { $and: [body?.filter_conditions || {}, { disabled:false }] } };
      }
      const match = /\/channels\/team\/(instance-([A-Za-z0-9_-]+?)(?:-internal)?)(?:\/|$)/.exec(path);
      if (match && (orgId === JAB_CHAT_ORG || body?.data?.team === JAB_CHAT_ORG)) {
        if (orgId !== JAB_CHAT_ORG) throw new Error("Select the channel's organization before opening job chat.");
        const result = await access(orgId, match[2], match[1]);
        if (!result || result.allowed !== true) {
          const error = new Error("Chat is unavailable for this job. " + (result?.reason || "Policy lookup failed."));
          error.code = "JOB_CHAT_SUPPRESSED"; error.status = 403;
          throw error;
        }
      }
      return original.call(this, url, body, ...rest);
    };
  }
  return client;
}
